import { createAction } from '@reduxjs/toolkit';
export const IGNORE_CALL = 'IGNORE_CALL';
export const ignoreCallAction = createAction(IGNORE_CALL);